import { inject } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { ActivityRecommendations } from '@shared-ui/local-expert-activities';
import { useBexApi } from '@shared-ui/bex-api-context';

import { DateUtils } from 'utils/date-utils';

import { Lazy } from 'components/common/lazy/lazy';

export const ActivityRecommendationsWrapper = inject('currentHotel')(({ currentHotel }) => {
  const { context } = useBexApi();

  const hotelRegion = currentHotel && currentHotel.hotel && currentHotel.hotel.region;
  const searchData = currentHotel && currentHotel.offerSearchData;

  return (
    <ErrorBoundary label="hotel.information.activities">
      <>
        {context && hotelRegion && hotelRegion.id && searchData && searchData.startDate && searchData.endDate && (
          <Lazy>
            <Lazy.Placeholder>
              <div data-stid="recommended-activities__placeholder" />
            </Lazy.Placeholder>
            <Lazy.Loaded>
              <AbacusExperiment name="LS_PWA_RECOMMENDED_ACTIVITIES">
                <AbacusControl />
                <AbacusVariant bucket={1}>
                  <ActivityRecommendations
                    inputs={{
                      context,
                      region: {
                        regionId: String(hotelRegion.id)
                      },
                      dateRange: {
                        startDate: DateUtils.parseDateString(searchData.startDate),
                        endDate: DateUtils.parseDateString(searchData.endDate)
                      }
                    }}
                    skipSsr={true}
                  />
                </AbacusVariant>
              </AbacusExperiment>
            </Lazy.Loaded>
          </Lazy>
        )}
      </>
    </ErrorBoundary>
  );
});
